module.exports = __webpack_public_path__ + "static/media/image copy.91ec614c.png";